module.exports = __webpack_public_path__ + "img/Logo-Mealkit-default.94832828.svg";